/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const CustomSativa24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Custom Sativa 24">
      <path
        fill="#0E0E0E"
        d="M11.036 1.53a2 2 0 0 1 1.928 0l8 4.4A2 2 0 0 1 22 7.683v8.634a2 2 0 0 1-1.036 1.753l-8 4.4a2 2 0 0 1-1.928 0l-8-4.4A2 2 0 0 1 2 16.317V7.683A2 2 0 0 1 3.036 5.93l8-4.4Z"
        className="Fill-Main"
      />
      <path
        fill="#fff"
        d="m8.638 15.505 1.443-1.209a2.457 2.457 0 0 0 2.002 1.092c.74 0 1.235-.364 1.235-.897 0-.52-.377-.884-1.287-1.196l-.78-.273c-1.482-.52-2.275-1.378-2.275-2.639 0-1.742 1.326-2.769 3.12-2.769 1.13 0 2.119.39 2.912 1.274l-1.248 1.287c-.442-.533-1.014-.793-1.651-.793s-1.235.273-1.235.819c0 .559.455.806 1.43 1.157l.74.273c1.353.494 2.198 1.352 2.198 2.743-.013 1.651-1.326 2.782-3.237 2.782-1.47 0-2.704-.637-3.367-1.651Z"
        className="Details"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: CustomSativa24,
  md: CustomSativa24,
  lg: CustomSativa24,
  xl: CustomSativa24,
  xxl: CustomSativa24,
  xxxl: CustomSativa24,
};

export const CustomSativaIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'custom-sativa-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
